import React from 'react';
import { StyledToggleButton } from './SegmentedControl.styles';
import { ToggleButtonGroup } from '@mui/material';
import { SegmentedControlHandleChange, SegmentedControlProps } from './SegmentedControl.types';

export const SegmentedControl: React.FC<SegmentedControlProps> = (props) => {
  const { options, value, onChange, clearable = false } = props;

  const handleChange: SegmentedControlHandleChange = (_, newValue) => {
    // if implementation is not "clearable", prevent default of setting value to null
    if (!newValue && !clearable) return;

    onChange(newValue);
  };

  return (
    <ToggleButtonGroup value={value} onChange={handleChange} exclusive data-testid="segmented-control">
      {options.map(({ label, disabled = false }) => {
        const value = label.replace(/[^a-z0-9]+/gi, '-');

        return (
          <StyledToggleButton value={label} key={`toggle-button--${value}`} disabled={disabled}>
            {label}
          </StyledToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

export default SegmentedControl;
